module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('h2', [_vm._v("订单查询")]), _vm._v(" "), _c('v-form', {
    staticStyle: {
      "width": "100%",
      "margin-top": "40px"
    },
    attrs: {
      "label-width": "6em",
      "model": _vm.form
    }
  }, [_c('v-form-item', {
    attrs: {
      "label": "订单号"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.id),
      expression: "form.id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.id = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-form-item', {
    attrs: {
      "label": "联系人手机"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.customerPhone),
      expression: "form.customerPhone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.customerPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.customerPhone = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-form', {
    staticStyle: {
      "width": "100%",
      "margin-top": "30px"
    },
    attrs: {
      "label-width": "6em",
      "model": _vm.form
    }
  }, [_c('v-form-item', {
    attrs: {
      "label": "订单状态"
    }
  }, [_c('v-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.orderState),
      callback: function($$v) {
        _vm.orderState = $$v
      },
      expression: "orderState"
    }
  }, _vm._l((_vm.ORDER_STATE_LIST), function(item) {
    return _c('v-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('v-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchOrder
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('h2', [_vm._v("查询结果"), _c('v-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出订单")])], 1), _vm._v(" "), _c('v-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticStyle: {
      "width": "100%",
      "background-color": "#FFF",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.tableData,
      "column": _vm.tableColumn
    },
    on: {
      "getOrderDetails": _vm.getOrderDetails
    },
    scopedSlots: _vm._u([{
      key: "productInfo",
      fn: function(props) {
        return [_c('div', [_vm._v("产品名称：" + _vm._s(props.data.productName))]), _vm._v(" "), _c('div', [_vm._v("产品编号：" + _vm._s(props.data.productNo))]), _vm._v(" "), _c('div', [_vm._v("货号：" + _vm._s(props.data.goodsNo))])]
      }
    }, {
      key: "customerInfo",
      fn: function(props) {
        return [_c('div', [_vm._v(_vm._s(props.data.customerName))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(props.data.customerPhone))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(props.data.customerAddress))])]
      }
    }])
  }), _vm._v(" "), _c('v-pagination', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "current": _vm.currentPage,
      "total": Math.ceil(_vm.totalCount / 20),
      "size": 'md',
      "first": false,
      "last": false
    },
    on: {
      "current-change": function($event) {
        _vm.currentChangeFunc($event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6626d1b8","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/wenchuang/orderList/Main.vue
// module id = 935
// module chunks = 0